import React from 'react'
import './Teampictures.css'

const Teampictures = () => {
    return (
        <>
            <div className="container-fluid my-5">
                <div className="container">
                    <h1 className='myheading fw-bold team-heading'>Team Pictures</h1>
                </div>
                <div className="row">
                    <div className="col-12 col-md-3 p-0">
                        <div className='team-card'>
                            <img src="https://preview.colorlib.com/theme/evento/assets/img/speakers/s1.png.webp" alt="team" width="100%" height="100%" />
                            <div className='team-card-inner'>
                                <h5 className='team-member-name'>Daniyal Saleem</h5>
                                <p className='team-member-pos'>CEO - TechX</p>
                            </div>
                        </div>

                    </div>
                    <div className="col-12 col-md-3 p-0">
                        <div className='team-card'>
                            <img src="	https://preview.colorlib.com/theme/evento/assets/img/speakers/s2.png.webp" alt="team" width="100%" height="100%" />
                            <div className='team-card-inner'>
                                <h5 className='team-member-name'>Hamza Aslam</h5>
                                <p className='team-member-pos'>Software Engineer - TechX</p>
                            </div>
                        </div>

                    </div>
                    <div className="col-12 col-md-3 p-0">
                        <div className='team-card'>
                            <img src="https://preview.colorlib.com/theme/evento/assets/img/speakers/s3.png.webp" alt="team" width="100%" height="100%" />
                            <div className='team-card-inner'>
                                <h5 className='team-member-name'>Ayesha khan</h5>
                                <p className='team-member-pos'>Marketing Manager - TechX</p>
                            </div>
                        </div>

                    </div>
                    <div className="col-12 col-md-3 p-0">
                        <div className='team-card'>
                            <img src="https://preview.colorlib.com/theme/evento/assets/img/speakers/s4.png.webp" alt="team" width="100%" height="100%" />
                            <div className='team-card-inner'>
                                <h5 className='team-member-name'>Feroze Khan</h5>
                                <p className='team-member-pos'>Financial Analyst - TechX</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-3 p-0">
                        <div className='team-card'>
                            <img src="https://preview.colorlib.com/theme/evento/assets/img/speakers/s1.png.webp" alt="team" width="100%" height="100%" />
                            <div className='team-card-inner'>
                                <h5 className='team-member-name'>Khurram khattak</h5>
                                <p className='team-member-pos'>Graphic Designer - TechX</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-3 p-0">
                        <div className='team-card'>
                            <img src="https://preview.colorlib.com/theme/evento/assets/img/speakers/s2.png.webp" alt="team" width="100%" height="100%" />
                            <div className='team-card-inner'>
                                <h5 className='team-member-name'>Muhammad Bilal</h5>
                                <p className='team-member-pos'>Operations Manager - TechX</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-3 p-0">
                        <div className='team-card'>
                            <img src="https://preview.colorlib.com/theme/evento/assets/img/speakers/s3.png.webp" alt="team" width="100%" height="100%" />
                            <div className='team-card-inner'>
                                <h5 className='team-member-name'>Dua khan</h5>
                                <p className='team-member-pos'>Product Manager - TechX</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-3 p-0">
                        <div className='team-card'>
                            <img src="https://preview.colorlib.com/theme/evento/assets/img/speakers/s4.png.webp" alt="team" width="100%" height="100%" />
                            <div className='team-card-inner'>
                                <h5 className='team-member-name'>Abdul Rafay</h5>
                                <p className='team-member-pos'>Corporate Lawyer - TechX</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Teampictures